const usernameToAbbr = (username) =>
  username
    ? username
        .split(' ')
        .filter(Boolean)
        .map((i) => i.slice(0, 1))
    : '';

export default usernameToAbbr;
